import { OnInit, OnDestroy, ElementRef, AfterViewInit, Renderer2, } from "@angular/core";
import { BrowsingService } from "../../services/browsing.service";
import { UserService } from "../../services/user.service";
var BrowseByComponent = /** @class */ (function () {
    function BrowseByComponent(browsingService, renderer, element, userService) {
        this.browsingService = browsingService;
        this.renderer = renderer;
        this.element = element;
        this.userService = userService;
        this.subscriptions = [];
        this.disciplines = [];
        this.view = 1;
        this.mobileSubjectTitle = "";
        this.view3Discipline = null;
        this.gtmPrefix = "gtm-browse-by-section-";
        this.setOn = "any"; // can be homepage
        this.mobileView = false;
        this.colorClasses = [
            {
                disciplineID: 8337,
                className: "science-color",
            },
            {
                disciplineID: 3026,
                className: "social-color",
            },
            {
                disciplineID: 1184,
                className: "math-color",
            },
            {
                disciplineID: 1880,
                className: "ela-color",
            },
            {
                disciplineID: 8353,
                className: "tech-color",
            },
            {
                disciplineID: 2806,
                className: "health-color",
            },
            {
                disciplineID: 2949,
                className: "prek-color",
            },
            {
                disciplineID: 6708,
                className: "prof-color",
            },
            {
                disciplineID: 2663,
                className: "arts-color",
            },
            {
                disciplineID: 6267,
                className: "languages-color",
            },
        ];
    }
    BrowseByComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subscriptions.push(this.browsingService.getSubjectsTree().subscribe(function (data) {
            _this.disciplines = data;
        }, function (error) { return console.error("[CUSTOM Error]" + error); }));
    };
    BrowseByComponent.prototype.ngAfterViewInit = function () {
        this.fixHeight();
    };
    BrowseByComponent.prototype.getAvailableSubjects = function (discipline) {
        return discipline.children.filter(function (node) { return node.resultsCount > 0; });
    };
    BrowseByComponent.prototype.ngOnDestroy = function () {
        this.subscriptions.map(function (subscription) { return subscription.unsubscribe(); });
    };
    BrowseByComponent.prototype.setView = function (view, subjectTitle, discipline) {
        if (subjectTitle === void 0) { subjectTitle = ""; }
        if (discipline === void 0) { discipline = null; }
        this.view = view;
        this.fixHeight();
        this.mobileSubjectTitle = subjectTitle;
        if (discipline) {
            this.view3Discipline = discipline;
        }
    };
    BrowseByComponent.prototype.fixHeight = function () {
        var _this = this;
        setTimeout(function () {
            var view = ".view" + _this.view;
            var viewEl = _this.element.nativeElement.querySelector(view);
            if (viewEl) {
                var h = viewEl.offsetHeight.toString();
                _this.renderer.setAttribute(_this.fakeView.nativeElement, "style", "height:" + h + "px");
            }
        }, 1);
    };
    BrowseByComponent.prototype.getColorClass = function (discipline) {
        var _a;
        return _a = {}, _a[this.getColorClassString(discipline)] = true, _a;
    };
    BrowseByComponent.prototype.getColorClassString = function (discipline) {
        var itemClass = "";
        this.colorClasses.map(function (colorClass) {
            if (discipline.id === colorClass.disciplineID) {
                itemClass = colorClass.className;
            }
        });
        return itemClass;
    };
    return BrowseByComponent;
}());
export { BrowseByComponent };
